import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useNavigate from '../hooks/useCanonicalNavigate';
import { useTheme } from './ThemeContext';
import { useLanguage } from './LanguageContext';
import { ProfilePreviewContext } from './ProfilePreviewNavigation';
import ProfilePreview from '../components/ProfilePreview/ProfilePreview';

export default function ProfilePreviewProvider({ children }) {
  const [person, setPerson] = useState(null);
  const navigate = useNavigate(), location = useLocation();
  const { theme } = useTheme(), { language } = useLanguage();
  const openPreview = useCallback(value => setPerson(value), []);
  useEffect(() => { setPerson(null); }, [location.key]);
  return <ProfilePreviewContext.Provider value={openPreview}>
    {children}
    {person && <ProfilePreview key={person.userId || person.id} person={person} theme={theme} language={language} onClose={() => setPerson(null)} onOpenProfile={id => navigate(`/profile/${encodeURIComponent(id)}`)}/>}
  </ProfilePreviewContext.Provider>;
}
